import React from 'react'
import {CalendarCell} from './cell'
import s from './monthly-calendar-grid.scss'
import {MonthlyCalendarPopup} from './popup'
import {MonthlyCalendarCellRefs, MonthlyCalendarCellSizes, MonthlyCalendarGridProps} from '.'

export class MonthlyCalendarGrid extends React.Component<MonthlyCalendarGridProps> {
  cellRefs: MonthlyCalendarCellRefs = {}

  getCellSizes = (): MonthlyCalendarCellSizes =>
    Object.entries(this.cellRefs).reduce((cellSizes, [week, weekRefs]) => {
      cellSizes[week] = Object.entries(weekRefs).reduce((weekSizes, [weekDay, ref]) => {
        const {clientWidth: width, clientHeight: height} = (ref as HTMLElement) ?? {}
        weekSizes[weekDay] = {width, height}

        return weekSizes
      }, {})

      return cellSizes
    }, {})

  registerCellContainerRef = (week: number, weekDay: number, ref: HTMLElement) => {
    this.cellRefs[week] = this.cellRefs[week] || {}
    this.cellRefs[week][weekDay] = ref
  }

  render() {
    const {shownDays, weekdayNames, borderStyle, t} = this.props

    return (
      <div className={s.grid}>
        <div className={s.weekDays}>
          {weekdayNames.map(name => (
            <div className={s.weekDay} key={name}>
              {name}
            </div>
          ))}
        </div>
        <div className={s.days}>
          {new Array(6).fill(null).map((_, week) => (
            <div className={s.week} style={borderStyle} key={week}>
              {new Array(7).fill(null).map((_, weekDay) => (
                <CalendarCell
                  key={shownDays[week * 7 + weekDay]}
                  timestamp={shownDays[week * 7 + weekDay]}
                  week={week}
                  weekDay={weekDay}
                  registerContainerRef={this.registerCellContainerRef}
                />
              ))}
            </div>
          ))}
          <MonthlyCalendarPopup getCellSizes={this.getCellSizes} t={t} />
        </div>
      </div>
    )
  }
}
